import { mapPeriodo } from "./mapPeriodo";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

/* --------------------------------------------
   LISTAR PERIODOS
-------------------------------------------- */
export async function getPeriodos() {
  try {
    console.log('🔍 Llamando al endpoint:', `${API_BASE}/catalogos/tipos-periodo-academico/`);
    const res = await fetch(`${API_BASE}/catalogos/tipos-periodo-academico/`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) {
      console.error("Error al obtener periodos:", res.status);
      return [];
    }

    const data = await res.json();
    console.log('📦 Datos recibidos del backend:', data);
    return Array.isArray(data) ? data.map(mapPeriodo) : [];
  } catch (e) {
    console.error("ERROR getPeriodos:", e);
    return [];
  }
}

/* --------------------------------------------
   CREAR PERIODO
-------------------------------------------- */
export async function createPeriodo(form) {
  const payload = {
    id_institucion: Number(form.institucion),
    nombre_periodo: form.nombre,
    codigo_periodo: form.codigo,
    periodos_por_anio: Number(form.numPorAno),
    duracion_semanas: Number(form.duracion),
    descripcion: form.descripcion ?? "",
    activo: form.estado === "ACTIVO",
  };

  const res = await fetch(`${API_BASE}/catalogos/tipos-periodo-academico/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    console.error(await res.text());
    throw new Error("Error al crear periodo");
  }

  return await res.json();
}

/* --------------------------------------------
   ACTUALIZAR PERIODO
-------------------------------------------- */
export async function updatePeriodo(id, form) {
  const payload = {
    id_institucion: Number(form.institucion),
    nombre_periodo: form.nombre,
    codigo_periodo: form.codigo,
    periodos_por_anio: Number(form.numPorAno),
    duracion_semanas: Number(form.duracion),
    descripcion: form.descripcion ?? "",
    activo: form.estado === "ACTIVO",
  };

  const res = await fetch(`${API_BASE}/catalogos/tipos-periodo-academico/${id}/`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    console.error(await res.text());
    throw new Error("Error al actualizar periodo");
  }

  return await res.json();
}

/* --------------------------------------------
   ELIMINAR PERIODO
-------------------------------------------- */
export async function deletePeriodo(id) {
  const res = await fetch(`${API_BASE}/catalogos/tipos-periodo-academico/${id}/`, {
    method: "DELETE",
    headers: getAuthHeaders()
  });

  if (!res.ok) {
    console.error(await res.text());
    throw new Error("Error al eliminar periodo");
  }

  return true;
}
